import React from 'react';

// Simple Modal for Success Message
const SuccessModal = ({ message, onClose, title = 'Success', variant = 'success' }) => {
  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <h2>{title}</h2>
        <p>{message}</p>
        <button onClick={onClose} style={{ ...modalStyles.button, backgroundColor: variant === 'danger' ? '#dc3545' : '#28a745' }} autoFocus>
          Close
        </button>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',  // Transparent black overlay
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0px 5px 15px rgba(0,0,0,0.2)',
  },
  button: {
    marginTop: '20px',
    padding: '10px 20px',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  }
};

export default SuccessModal;
